/**
 * Centralized configuration for environment variables.
 */
export const environment = {
  // The base URL of your Magnolia instance
  MAGNOLIA_BASE_URL: process.env.REACT_APP_MAGNOLIA_BASE_URL || 'http://localhost:8080',

  // The base path for your SPA in the Magnolia site structure (e.g., '/home')
  APP_BASE: process.env.REACT_APP_MGNL_APP_BASE || '/home',

  // Parent of all self-service storefronts. Any page tree created beneath it is served by
  // this app under its own base (/shops/<name>) with its own root page, brand, navigation
  // and site info; see utils/appBase.js.
  SHOPS_BASE: process.env.REACT_APP_MGNL_SHOPS_BASE || '/shops',

  // Component Factory. Factory items are pages in their own workspace, not under APP_BASE,
  // so a path starting with this prefix is read from that workspace instead of `website`.
  // The prefix is the factory's root node; it doubles as the browser path because the page
  // template's routeTemplate resolves to the item's full JCR path.
  COMPONENT_FACTORY_BASE: process.env.REACT_APP_MGNL_COMPONENT_FACTORY_BASE || '/component-factory-site-root',
  COMPONENT_FACTORY_WORKSPACE: process.env.REACT_APP_MGNL_COMPONENT_FACTORY_WORKSPACE || 'component-factory',

  // The two template ids the factory feature is wired to. They are configurable rather than
  // hardcoded in magnolia.config.js because the templates live in a project light module,
  // not here: a project that names them differently, or does not install the Component
  // Factory at all, needs no change in this app. An unmapped id simply never matches.
  COMPONENT_FACTORY_PAGE_TEMPLATE:
    process.env.REACT_APP_MGNL_COMPONENT_FACTORY_PAGE_TEMPLATE || 'feature-component-factory:pages/component-factory-headless',
  COMPONENT_FACTORY_LINK_TEMPLATE:
    process.env.REACT_APP_MGNL_COMPONENT_FACTORY_LINK_TEMPLATE || 'feature-component-factory:components/component-factory',
};
